import { Box, Heading, Text } from "@chakra-ui/react";
import React from "react";

/**
 * Page-level title row with optional subtitle and right-aligned actions (CTA slot).
 */
export default function PageHeader({
  title,
  description,
  actions = null,
  className = "",
}) {
  return (
    <Box
      as="header"
      className={className}
      mb={{ base: 6, md: 8 }}
      display="flex"
      flexDirection={{ base: "column", sm: "row" }}
      alignItems={{ base: "stretch", sm: "flex-start" }}
      justifyContent="space-between"
      gap={4}
    >
      <div className="min-w-0 flex-1">
        <Heading
          as="h1"
          size="lg"
          fontWeight="semibold"
          letterSpacing="-0.02em"
          color="gray.800"
          lineHeight="shorter"
        >
          {title}
        </Heading>
        {description ? (
          <Text mt={1} fontSize="sm" color="gray.600" maxW="xl">
            {description}
          </Text>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </Box>
  );
}
